import React from 'react';
import { isRouteAllowed, webUrlFor } from '../appMenu';
import { OpenOnWebScreen } from '../ui/screens';
import type { ShellTheme } from '../ui/tokens';

declare const __APP_MENU__: unknown;

/**
 * The route list a phone build was made with (spec §5.3, plan R3/R4), or null
 * for web and local builds. Defined by the app's Vite config from
 * APP_MENU_ROUTES; anything malformed is treated as web (never crash).
 */
export function readBuildAppMenu(): string[] | null {
  let v: unknown;
  try { v = typeof __APP_MENU__ === 'undefined' ? (globalThis as any).__APP_MENU__ : __APP_MENU__; } catch { v = (globalThis as any).__APP_MENU__; }
  return Array.isArray(v) && v.every((x) => typeof x === 'string') ? (v as string[]) : null;
}

/** Wraps the page area: a route switched off for this app renders "Open on the web". */
export function AppMenuRouteGuard({ allow, path, webOrigin, routing, theme, onBack, openUrl, children }: {
  allow: readonly string[] | null; path: string; webOrigin: string; routing: 'hash' | 'path'; theme: ShellTheme;
  onBack: () => void; openUrl?: (url: string) => void; children: React.ReactNode;
}) {
  if (isRouteAllowed(path, allow)) return <>{children}</>;
  const open = openUrl ?? ((u: string) => { window.open(u, '_blank'); });
  return <OpenOnWebScreen theme={theme} onOpenWeb={() => open(webUrlFor(path, webOrigin, routing))} onBack={onBack} />;
}
